import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import './MenuPanel.css'

import bemClass from './../../../utils/bemClass'

const cn = bemClass('MenuPanel')

class Item extends PureComponent {
    handleClick = () => {
        const { onChange, active } = this.props

        if (active) {
            return
        }

        onChange()
    }

    render() {
        const { className, active, title, url } = this.props
 
        return (
            <li className={`${cn('item', { active })} ${className}`} onClick={this.handleClick}>
                <Link to={url} className={cn('link', { active })}>
                    {title}
                </Link>
            </li>
        )
    }
}

Item.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    id: PropTypes.number,
    onChange: PropTypes.func,
    active: PropTypes.bool,
}

Item.defaultProps = {
    onChange: () => {},
    className: '',
    url: '',
    title: '',
    active: false,
}

export default Item


// WEBPACK FOOTER //
// ./src/components/Menu/MenuPanel/Item.jsx